import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const ContactMe = () => {
    return (
        <div className='py-5 px-10'>
            <h1 className='text-center text-2xl text-green-500 font-semibold'
                data-aos="fade-down"
                data-aos-duration="800"
            >CONTACT ME</h1>
            <h3 className='text-center text-3xl font-semibold py-2 mb-4'
                data-aos="fade-down"
                data-aos-duration="1000"
            >GET IN TOUCH</h3>
            <div className='grid gap-10  lg:grid-cols-3 md:grid-cols-2 grid-cols-1 '>
                <div className=' text-center  custom_shadow rounded-2xl px-3 py-5'
                    data-aos="fade-down"
                    data-aos-easing="linear"
                    data-aos-duration="500"
                >
                    <h2 className='text-green-500 text-3xl'> <a href="tel:+8801729107200"> <FontAwesomeIcon icon={faPhone} /> </a></h2>
                    <h1 className='text-gray-600 text-2xl font-semibold'> <a href="tel:+8801729107200">Phone</a></h1>
                    <h3 className='text-lg text-gray-500'> <a href="tel:+8801729107200"> +8801729107200</a> </h3>
                </div>
                <div className=' text-center custom_shadow  rounded-2xl px-3 py-5 '
                    data-aos="fade-down"
                    data-aos-easing="linear"
                    data-aos-duration="1000"
                >
                    <h2 className='text-green-500 text-3xl'> <FontAwesomeIcon icon={faEnvelope} /> </h2>
                    <h1 className='text-gray-600 text-2xl font-semibold'>Email</h1>
                    <h3 className='text-lg text-gray-500'>ahmedshakil0512@gmail.com</h3>
                </div>
                <div className='text-center custom_shadow  rounded-2xl px-3 py-5'
                    data-aos="fade-down"
                    data-aos-easing="linear"
                    data-aos-duration="1500"
                >
                    <h2 className='text-green-500 text-3xl'><FontAwesomeIcon icon={faLocationDot} /> </h2>
                    <h1 className='text-gray-600 text-2xl font-semibold'>Address</h1>
                    <h3 className='text-lg text-gray-500'>Gazipur, Dhaka, Bangladesh</h3>
                </div>
            </div>
        </div>
    );
};

export default ContactMe;